import type { YjsTransportStatus } from "./types";

// Hocuspocus reports "connecting" both on first connect and on reconnect; we
// surface it as "reconnecting" (the banner copy is reconnect-oriented and the
// initial-connect window is covered by the sync gate, not this status).
export const mapHocuspocusStatus = (
  status: "connecting" | "connected" | "disconnected",
): YjsTransportStatus => {
  if (status === "connected") return "connected";
  if (status === "disconnected") return "disconnected";
  return "reconnecting";
};
